// import createGenerateClassName from '@mui/styles/createGenerateClassName';
// import jssPreset from '@mui/styles/jssPreset';
// import { create } from 'jss';
// import jssExtend from 'jss-plugin-extend';
// import rtl from 'jss-rtl';
import Provider from 'react-redux/es/components/Provider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StyledEngineProvider } from '@mui/material/styles';

import 'dayjs/locale/es';

import store from './store';

const withAppProviders = (Component) => (props) => {
  const WrapperComponent = () => (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
        <StyledEngineProvider injectFirst>
          <Component {...props} />
        </StyledEngineProvider>
      </LocalizationProvider>
    </Provider>
  );

  return WrapperComponent;
};

export default withAppProviders;
